var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2409 12L8.33474 7.70711C7.88842 7.31658 7.88842 6.68342 8.33474 6.29289C8.78105 5.90237 9.50467 5.90237 9.95098 6.29289L15.6653 11.2929C16.1116 11.6834 16.1116 12.3166 15.6653 12.7071L9.95098 17.7071C9.50467 18.0976 8.78105 18.0976 8.33474 17.7071C7.88842 17.3166 7.88842 16.6834 8.33474 16.2929L13.2409 12Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinRightChevron);
export default __webpack_public_path__ + "static/media/thin-right-chevron.5d8c46d3.svg";
export { ForwardRef as ReactComponent };